module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.9@core-js/library/modules/_iter-step.js
// module id = lZSZ
// module chunks = 0